import createReducer from 'redux/utils/createReducer';
import { HYDRATE } from 'next-redux-wrapper';
import types from './types';
const fa = require('translations/fa.json');

// Set initial state
export const initialState = {
   appointment: {},
   webConfig: {lang: 'fa', translation: fa, dir: 'rtl', fontFamily: 'Samim'},
   appPromptClose: false,
   languageSelection: false,
   firebaseRemoteConfigs: {},
   deleteAccRequest: false,
   doctorsList: [],
}

const coreReducer = createReducer(initialState, {

    [types.SET_APPOINTMENT](state, action) {
        if (!action.appointment) return state;
        
        return {
            ...state,
            appointment: {...action.appointment},
        };
    },

    [types.SET_FIREBASE_REMOTE_CONFIGS](state, action) {
        if (!action.firebaseRemoteConfigs) return state;
        
        return {
            ...state,
            firebaseRemoteConfigs: {...action.firebaseRemoteConfigs},
        };
    },

    [types.SET_WEB_CONFIG](state, action) {
        if (!action.webConfig) return state;
        
        return {
            ...state,
            webConfig: {...action.webConfig},
        };
    },

    [types.SET_DELETE_ACC_REQUEST](state, action) {  
        return {
            ...state,
            deleteAccRequest: action.deleteAccRequest,
        };
    },

    [types.SET_APP_PROMPT_CLOSE](state, action) {  
        return {
            ...state,
            appPromptClose: action.appPromptClose,
        };
    },

    [types.SET_LANGUAGE_SELECTION](state, action) {  
        return {
            ...state,
            languageSelection: action.languageSelection,
        };
    },

    [types.SET_DOCTORS](state, action) {
        if (!action.doctorsList) return state;
        
        return {
            ...state,
            doctorsList: [...action.doctorsList],
        };
    },

    [HYDRATE]: (state, { payload }) => ({
        ...state,
        ...payload.core,
    }),
});

export default coreReducer;

